import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "app" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_app, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_main, { class: "bg-blue-grey-lighten-4" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_container, {
              fluid: "",
              class: "d-flex justify-center bg-blue-grey-lighten-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "3" }),
                    _createVNode(_component_v_col, { cols: "6" }, {
                      default: _withCtx(() => _cache[0] || (_cache[0] = [
                        _createElementVNode("p", { class: "font-weight-black d-flex justify-center text-h5" }, " BeamerAI - Layout-Vorschläge ", -1)
                      ])),
                      _: 1,
                      __: [0]
                    }),
                    _createVNode(_component_v_col, { cols: "3" })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider, { thickness: 2 }),
            _createVNode(_component_router_view)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}